<template>
	<Relatorio>
		<!-- right col (We are only adding the ID to make the widgets sortable)-->
		<section class="col-lg-12">
			<div class="card">
				<div class="card-header">
					<h3>Relatório de Avaliações</h3>
					<div class="card-tools">
						<!-- Maximize Button -->
						<button
							type="button"
							class="btn btn-tool"
							data-card-widget="maximize"
						>
							<i class="fas fa-expand"></i>
						</button>
					</div>
					<!-- /.card-tools -->
				</div>

				<!-- /.card-header -->
				<div class="card-body">
					<table
						id="tblRelatorio"
						class="table table-bordered table-striped dataTable"
						role="grid"
						aria-describedby="conteudos"
					>
						<thead>
							<tr role="row">
								<th rowspan="1" colspan="1">Data</th>
								<th rowspan="1" colspan="1">Pergunta</th>
								<th rowspan="1" colspan="1">Cliente</th>
								<th rowspan="1" colspan="1">Resposta</th>
								<th rowspan="1" colspan="1">#</th>
							</tr>
						</thead>
						<tbody>
							<tr
								role="row"
								class="odd"
								v-for="resposta in paginacao.data"
								:key="resposta.id"
							>
								<td class="sorting_1">
									<em>
										<span class="d-none">{{
											resposta.created_at
										}}</span>
										<!-- PARA ORDENAR O DTTABLE -->
										{{
											resposta.created_at
												| moment("DD/MM HH:mm")
										}}
									</em>
									<br />
									<small>#{{ resposta.id }}</small>
								</td>
								<td>{{ resposta.pergunta.pergunta }}</td>
								<td>{{ resposta.client.nome_fantasia }}</td>
								<td>{{ resposta.resposta }}</td>
								<td class>
									<button
										type="button"
										class="btn btn-block btn-outline-danger btn-xs m-2"
										v-on:click.stop="showConfirm(resposta)"
									>
										excluir
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- PAGINACAO -->
				<div class="card-footer clearfix">
					<ul class="pagination pagination-sm m-0 float-left">
						<li class="text-gray">
							Total <b>{{ paginacao.total }}</b> registros em
							<b>{{ paginacao.last_page }}</b> páginas.
						</li>
					</ul>
					<ul class="pagination pagination-sm m-0 float-right">
						<li class="mr-2 text-gray" style="margin-top: 2px">
							Mostrando página <b>{{ paginacao.current_page }}</b>
						</li>
						<li
							v-for="(pagina, indx) in paginas"
							class="paginate_button page-item"
							v-bind:class="{ active: pagina.active }"
							v-bind:key="indx"
						>
							<a
								:title="pagina.title"
								v-on:click="getPage(pagina.number)"
								class="page-link"
								style="cursor: pointer"
								>{{ pagina.label }}</a
							>
						</li>
					</ul>
				</div>
				<!-- ./Paginacao -->
			</div>
		</section>
		<!-- right col -->
	</Relatorio>
</template>
<style>
.cursor-pointer {
	cursor: pointer;
}
.note-float-left,
note-float-right {
	padding: 4px;
}
</style>
<script>
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import Relatorio from "../../components/Relatorio.vue";

export default {
	name: "relatorio-avaliacao",
	data() {
		return {
			titulo: "Carregando lista...",
			avaliacao_mensal_url: this.$apiUrl + "/avaliacao_mensal_resposta",
			login: {},
			loginObj: {},
			isAdmin: false,
			table: false,
			editar: false,
			paginacao: [],
			paginas: [],
		};
	},
	methods: {
		getAvaliacaoMensalRespostas() {
			var estado_url = this.avaliacao_mensal_url;

			axios
				.get(estado_url, this.login)
				.then((response) => {
					this.paginacao = response.data;
					//this.dataTable();
					this.pagination();
				})
				.catch((error) => {
					this.showalert("Atenção", error, "error");
				});
		},

		deleteResposta(resposta) {
			var deleteurl = this.avaliacao_mensal_url + "/" + resposta.id;

			axios.delete(deleteurl, this.login).then((response) => {
				var _t = this;

				_t.retorno = response.data;

				if (_t.retorno.status == 201) {
					_t.getAvaliacaoMensalRespostas();

					_t.showalert(
						"Cadastro Excluído",
						_t.retorno.message,
						"success",
					);
				} else {
					const msg = Object.entries(_t.retorno.message); //CONVERTE OBJETO EM ARRAY COM OS VALORES 'entries'

					for (var i = 0; i < msg.length; i++) {
						var msgerro = msg[i][1];

						_t.showalert("Atenção", msgerro, "error");
					}
				}
			});
		},
		showConfirm(resposta) {
			this.$fire({
				title: "Excluir",
				text:
					"Você tem certeza que deseja excluir #" + resposta.id + "?",
				type: "question",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				confirmButtonText: "Sim, excluir!",
				cancelButtonColor: "#d33",
				cancelButtonText: "Não",
			}).then((result) => {
				if (result.value) {
					this.deleteResposta(resposta);
				}
			});
		},
		dataTable() {
			var _e = this;

			if (_e.table != false) {
				_e.table.destroy();

				setTimeout(() => {
					_e.renderTable();
				}, 100);
			} else {
				setTimeout(() => {
					_e.renderTable();
				}, 100);
			}
		},
		renderTable() {
			this.table = $("#tblRelatorio").DataTable({
				paging: true,
				bInfo: true,
				bLengthChange: false,
				searching: true,
				order: [[0, "desc"]],
				language: {
					sEmptyTable: "Pesquisando registros...",
					sInfo:
						"Mostrando de _START_ até _END_ de _TOTAL_ registros",
					sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
					sInfoFiltered: "(Filtrados de _MAX_ registros)",
					sInfoPostFix: "",
					sInfoThousands: ".",
					sLengthMenu: "_MENU_ resultados por página",
					sLoadingRecords: "Carregando...",
					sProcessing: "Processando...",
					sZeroRecords: "Nenhum registro encontrado",
					sSearch: "Pesquisar",
					oPaginate: {
						sNext: "Próximo",
						sPrevious: "Anterior",
						sFirst: "Primeiro",
						sLast: "Último",
					},
					oAria: {
						sSortAscending: ": Ordenar colunas de forma ascendente",
						sSortDescending:
							": Ordenar colunas de forma descendente",
					},
					select: {
						rows: {
							_: "Selecionado %d linhas",
							"0": "Nenhuma linha selecionada",
							"1": "Selecionado 1 linha",
						},
					},
				},
			});
		},
		getPage(pagina) {
			axios
				.get(this.avaliacao_mensal_url + "?page=" + pagina)
				.then((response) => {
					this.paginacao = response.data;
					//this.dataTable();
					this.pagination();
				})
				.catch((error) => {
					this.showalert("Atenção", error, "error");
				});
		},
		pagination() {
			this.paginas = [];

			var totalPaginas = this.paginacao.total / this.paginacao.per_page;
			var pagina = {};
			var i = 1;

			totalPaginas = Math.ceil(totalPaginas);

			for (i = 1; i <= totalPaginas; i++) {
				pagina = {};

				if (this.paginacao.current_page == i) {
					pagina.active = true;
				} else {
					pagina.active = false;
				}

				if (i == 1) {
					//primeira pagina
					pagina.label = "«";
					pagina.number = i;
					pagina.title = "Primeira Página";
					this.paginas.push(pagina);
				} else if (i == totalPaginas) {
					//ultima pagina
					pagina.label = "»";
					pagina.number = i;
					pagina.title = "Última Página";
					this.paginas.push(pagina);
				} else {
					// index +- 2
					if (
						this.paginacao.current_page >= i - 5 &&
						this.paginacao.current_page < i + 5
					) {
						pagina.label = i;
						pagina.title = "Página " + i;
						pagina.number = i;
						this.paginas.push(pagina);
					}
				}
			}
		},
	},
	mounted() {
		this.contador_login = localStorage.getItem("contador");

		if (localStorage.getItem("login")) {
			try {
				const loginJSON = JSON.parse(localStorage.getItem("login"));

				this.loginObj = loginJSON;

				this.isAdmin = loginJSON.isAdmin;

				this.login = {
					headers: {
						Authorization: "Bearer ".concat(loginJSON.api_token),
						Accept: "application/json",
						"Cache-Control": "no-cache",
					},
				};

				setTimeout(() => {
					this.getAvaliacaoMensalRespostas();
				}, 300);
			} catch (e) {
				localStorage.removeItem("login");
				this.$router.push("/login");
			}
		} else {
			localStorage.removeItem("login");
			this.$router.push("/login");
		}
	},
	destroyed() {
		localStorage.contador = 0;
	},
	components: {
		Relatorio,
	},
};
</script>
